import React from 'react';
import { Modal, Spin } from 'antd';

interface Closable {
  closable: boolean
}

const Loader: React.FC<Closable> = ({ closable }) => (
  <Modal
    open={true}
    footer={null} // Removes footer buttons
    closable={closable} // Removes the close icon
    centered // Centers the modal on the screen
    maskClosable={false} // Prevent closing by clicking outside
    width={70} // Optional: Customize modal width
  >
    <div className="flex justify-center items-center h-32 w-full">
      <Spin size="large" />
    </div>
  </Modal>
);

export default Loader;